import { render, staticRenderFns } from "./funnel-others.md?vue&type=template&id=5866f203&"
import script from "./funnel-others.md?vue&type=script&lang=js&"
export * from "./funnel-others.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5866f203')) {
      api.createRecord('5866f203', component.options)
    } else {
      api.reload('5866f203', component.options)
    }
    module.hot.accept("./funnel-others.md?vue&type=template&id=5866f203&", function () {
      api.rerender('5866f203', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Funnel/funnel-others.md"
export default component.exports